export const orders = {
  title: `Orders`,
};
